import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map } from 'rxjs/operators';
import * as dayjs from 'dayjs';

//SERVICES
import { ConfigService } from '../services/config.service';
//MODELS
import { Observable, of, Subscriber, throwError } from 'rxjs';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CruiseLine } from '../models/cruise-line.interface';
import { Itinerary } from '../models/itinerary.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';
import { CruiseLineSailDate } from '../models/cruise-line-sail-date.interface';
import { CartTest } from '../models/cart-test.interface';

@Injectable({providedIn: SharedModule})
export class CompassAPICruiseSearchService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService
	) {

		this.config = this._configService.getCompassApi();
		//console.log('this.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'cruisesearch';
	}


	/**
	 * Get Cruise Lines
	 * @returns
	*/
	public getCruiseLines (): Observable<CruiseLine[]>{
		let url = new URL(this.baseUrl + '/cruiselineslist');
		//console.log('API.getCruiseLines().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getCruiseLines.res:', res);
				return res.results;
			}), catchError(err =>
        {
          //throwError(err)
          console.log('an error occured ************************************************', err);
          return throwError(err);
        }
      ));
	}

  public cartTest () : Observable<CartTest[]>{
		let url = new URL(this.config.baseUrl+"carts/test");
		//('API.getCarts().url', String(url));
    let error = null;
    return this.httpClient
    .get(String(url))
    .pipe(
      // catchError(err => of({"error": err}))
      catchError((error:any) => {
          console.log("Issues? " +  error);
          return 'something went wrong in post cart';
      })
    )
    .pipe(map((res: CompassApiResponse) => {
      console.log('API.getCruiseLines.res:', res);
      return res.results;
    }), catchError(err =>
      {
        //throwError(err)
        console.log('an error occured ************************************************', err);
        return throwError(err);
      }
    ));

      var flag = true;
	}


    /**
	 * Get Cruise Lines Ship Names
	 * @returns
	*/
	public getCruiseLineShipNames (cruiseLineId: string): Observable<string[]>{
		let url = new URL(this.baseUrl + '/cruiselineshipnameslist');
		if(cruiseLineId) url.searchParams.append('cruiseLineId', cruiseLineId);
		//console.log('API.getCruiseLineShipNames().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getCruiseLineShipNames.res:', res);
				return res.results;
			}));
	}


	/**
	 * Get Cruise Lines Ship Sail Dates
	 * @returns
	*/
	public getCruiseLineShipSailDates (cruiseLineId: string, shipName: string, isDateFiltered: boolean = true): Observable<CruiseLineSailDate[]>{
		let url = new URL(this.baseUrl + '/cruiselineshipsailedates');
		if(cruiseLineId) url.searchParams.append('cruiseLineId', cruiseLineId);
		if(shipName) url.searchParams.append('shipName', shipName);
		//console.log('API.getCruiseLineShipSailDates().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getCruiseLineShipSailDates.res:', res);
				if (isDateFiltered) {
					return this.filterSailDates(res.results);
				} else {
					return res.results;
				}

				//return res.results;
			}));
	}


	public filterSailDates(results: any){
		const now = dayjs();
		// console.log('filterSailDates.today:', dayjs().format('YYYY-MM-DD'));
		// console.log('filterSailDates.results:', results);
		results.forEach(cruise => {
			//console.log('date:', now.format('YYYY-MM-DD'), 'vs', dayjs(cruise.sailDate).format('YYYY-MM-DD'), now.diff(dayjs(cruise.sailDate), 'day'));
		});
		const filteredResults = results.filter(cruise => now.diff(dayjs(cruise.sailDate), 'day') <= 0 );
		//console.log('filterSailDates.filteredResults:', filteredResults);
		return filteredResults;

	}


	/**
	 * Get Cruise Lines Ship Itinerary
	* @param CodeToCruiseId
	*/
	public getCruiseLineShipItinerary (codeToCruiseId : string): Observable<Itinerary>{
		let url = new URL(this.baseUrl + '/itinerary');
		if(codeToCruiseId) url.searchParams.append('codeToCruiseId', codeToCruiseId);
		// if(cruiseLineId) url.searchParams.append('cruiseLineId', cruiseLineId);
		// if(shipName) url.searchParams.append('shipName', shipName);
		// if(sailDate) url.searchParams.append('sailDate', sailDate);
		//console.log('API.getCruiseLineShipItinerary().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getCruiseLineShipItinerary.res:', res);
				//return res.results;
				if(res.status == CompassApiStatusEnum.ok) {
					return res;
				} else {
					console.error('API.getCruiseLineShipItinerary.res:', res);
					return res;//uses error
				}
			}));
	}

}
